module.exports = __webpack_public_path__ + "d69b9c431532e5f2bc9230001296a21a.ttf";